import { Banner, Button } from '@shopify/polaris';
import { useTranslation } from 'react-i18next';

import { FAQ_DATA_NUMBERS_TAB } from '../constants';
import { useFaqStore } from '../stores';

/** "FAQ about data numbers" entry used across the analytics screens. Opens the Data accuracy tab. */
export const FaqDataNumbersTrigger: React.FC = () => {
  const { t } = useTranslation();
  const open = useFaqStore((state) => state.open);

  return (
    <Banner tone="info">
      <Button variant="plain" onClick={() => open({ tab: FAQ_DATA_NUMBERS_TAB })}>
        {t('FAQ about data numbers')}
      </Button>
    </Banner>
  );
};
